import React from 'react';

import BaseLibraryIconSvg from '@/components/Icon/BaseLibraryIconSvg';
import { StarInterface } from '@/components/StarRatingComponent/Star';

const StarHalfFilled: React.FC<StarInterface> = ({
  width,
  isOnDark,
  color,
  viewBox,
}) => {
  return (
    <BaseLibraryIconSvg
      name={`star-half-filled-${isOnDark ? 'dark' : 'light'}`}
      width={width}
      color={color}
      viewBox={viewBox}
    >
      <g clipPath='url(#clip0_6642_65904)'>
        <mask
          id='mask0_6642_65904'
          style={{ maskType: 'luminance' }}
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width={width}
          height={width}
        >
          <path d='M32 0H0V32H32V0Z' fill='white' />
        </mask>
        <g mask='url(#mask0_6642_65904)'>
          <path
            d='M16 25.5517L16.4016 25.8064L24.883 31.1847C25.0231 31.253 25.0952 31.2517 25.1182 31.249L25.1185 31.249C25.2065 31.2386 25.3066 31.2059 25.4231 31.131L25.4233 31.1308C25.4874 31.0896 25.5488 31.0257 25.601 30.9059L25.6011 30.9058C25.6259 30.8489 25.6399 30.7749 25.5993 30.6441L25.5903 30.6151L25.5837 30.5855L23.3204 20.467L23.2253 20.0421L23.5472 19.7489L31.036 12.9259L31.0447 12.9179L31.0537 12.9103C31.157 12.8219 31.2082 12.7342 31.2339 12.639C31.2603 12.5411 31.2526 12.4712 31.2232 12.4008C31.1638 12.2586 31.095 12.1679 31.0274 12.1075C30.9958 12.0792 30.9227 12.0312 30.7638 11.9984L20.9182 11.0974L20.4617 11.0556L20.2907 10.6304L16.4359 1.04697L16.4324 1.03831L16.4325 1.03829C16.372 0.882499 16.3125 0.837688 16.2881 0.823028L16.288 0.822944C16.2131 0.777973 16.1235 0.75 16 0.75C15.8765 0.75 15.7869 0.777973 15.712 0.822943L15.7119 0.823028C15.6875 0.837688 15.628 0.882498 15.5675 1.03829L15.5642 1.04699L15.5641 1.04697L11.7093 10.6304L11.5383 11.0556L11.0818 11.0974L1.23619 11.9984C1.07725 12.0312 1.00414 12.0792 0.972581 12.1074L0.972516 12.1075C0.904985 12.1679 0.836287 12.2585 0.776881 12.4007L16 25.5517ZM16 25.5517L15.5984 25.8064M16 25.5517L15.5984 25.8064M15.5984 25.8064L7.11695 31.1847C6.97696 31.253 6.9048 31.2517 6.8818 31.249L6.88143 31.249M15.5984 25.8064L6.88143 31.249M6.88143 31.249C6.79345 31.2386 6.6934 31.2059 6.57691 31.131L6.57675 31.1309M6.88143 31.249L6.57675 31.1309M6.57675 31.1309C6.51262 31.0896 6.45121 31.0257 6.39896 30.9058L5.7114 31.2054M6.57675 31.1309L5.7114 31.2054M5.7114 31.2054L6.39896 30.9058C6.37415 30.8489 6.36012 30.7748 6.4007 30.644L6.40968 30.6151M5.7114 31.2054L6.40968 30.6151M6.40968 30.6151L6.41629 30.5855M6.40968 30.6151L6.41629 30.5855M6.41629 30.5855L8.67957 20.467L8.77461 20.0421M6.41629 30.5855L8.77461 20.0421M8.77461 20.0421L8.45278 19.7489M8.77461 20.0421L8.45278 19.7489M8.45278 19.7489L0.96405 12.9259L0.955307 12.9179M8.45278 19.7489L0.955307 12.9179M0.955307 12.9179L0.946317 12.9102M0.955307 12.9179L0.946317 12.9102M0.946317 12.9102C0.843036 12.8219 0.791764 12.7342 0.766052 12.639L0.946317 12.9102ZM0.766004 12.6388C0.739788 12.5413 0.747409 12.4714 0.776794 12.4009L0.766004 12.6388Z'
            stroke={color}
            strokeWidth='1.5'
          />
          <mask
            id='mask1_6642_65904'
            style={{ maskType: 'alpha' }}
            maskUnits='userSpaceOnUse'
            x='0'
            y='0'
            width={width}
            height={width}
          >
            <path
              d='M16 26.4398L7.4878 31.8376C7.23831 31.967 7.00687 32.0191 6.79349 31.9938C6.58006 31.9686 6.37266 31.8913 6.17127 31.7618C5.96992 31.6324 5.81663 31.4469 5.7114 31.2054C5.60621 30.964 5.59721 30.7028 5.68438 30.4218L7.94766 20.3033L0.458935 13.4803C0.24852 13.3004 0.109494 13.0849 0.0418559 12.834C-0.0257427 12.583 -0.0114609 12.3424 0.084701 12.1119C0.180902 11.8815 0.31016 11.6937 0.472474 11.5485C0.63475 11.4033 0.854153 11.3054 1.13068 11.2549L11.0135 10.3505L14.8683 0.767082C14.9736 0.495589 15.1261 0.299868 15.326 0.17992C15.5258 0.0599723 15.7505 0 16 0C16.2495 0 16.4742 0.0599723 16.674 0.17992C16.8739 0.299868 17.0264 0.495589 17.1317 0.767082L20.9865 10.3505L30.8693 11.2549C31.1458 11.3054 31.3652 11.4033 31.5275 11.5485C31.6898 11.6937 31.8191 11.8815 31.9153 12.1119C32.0115 12.3424 32.0257 12.583 31.9581 12.834C31.8905 13.0849 31.7515 13.3004 31.5411 13.4803L24.0523 20.3033L26.3156 30.4218C26.4028 30.7028 26.3938 30.964 26.2886 31.2054C26.1834 31.4469 26.0301 31.6324 25.8287 31.7618C25.6273 31.8913 25.4199 31.9686 25.2065 31.9938C24.9931 32.0191 24.7617 31.967 24.5122 31.8376L16 26.4398Z'
              fill={color}
            />
          </mask>
          <g mask='url(#mask1_6642_65904)'>
            <rect x='-1' width='17' height='37' fill={color} />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id='clip0_6642_65904'>
          <rect width='32' height='32' fill='white' />
        </clipPath>
      </defs>
    </BaseLibraryIconSvg>
  );
};

export default StarHalfFilled;
